import { BlockRounded } from "@mui/icons-material";
import { Typography, styled, alpha } from "@mui/material";
import { fromArray, isArray } from "../../../utils/PropertyUtils";

interface Props {
  className?: string;
  label: string;
  value: string | number | undefined;
}

export function LayerProperty(props: Props) {
  const { label, value } = props;

  return render();

  function render() {
    return (
      <Styles className={props.className}>
        <Typography component="i" className="attribute-label">
          {label}
        </Typography>

        {renderValue()}
      </Styles>
    );
  }

  function renderValue() {
    if (value === undefined) return <BlockRounded />;

    // else
    if (isArray(value)) {
      const valueArray = fromArray(value.toString());

      return (
        <Typography className="attribute-value">
          {valueArray.map((valueItem, i) => {
            return (
              <div key={i} style={i > 0 ? { flexBasis: "100%" } : undefined}>
                {valueItem}
              </div>
            );
          })}
        </Typography>
      );
    } else {
      return <Typography className="attribute-value">{value}</Typography>;
    }
  }
}

const Styles = styled("div")`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  .attribute-label {
    color: ${({ theme }) => alpha(theme.palette.common.white, 0.8)};
    flex: 1 1 60%;
  }
  .attribute-value {
    flex: 0 1 40%;
    font-weight: 600;
    text-align: right;
  }
`;
